<template>
  <span
    v-if="token && token.sharia_compliant === true"
    class="sharia-badge"
    :class="size"
    title="The sponsor has marked this deal as following Sharia (Islamic finance) principles."
  >
    <svg viewBox="0 0 12 12" aria-hidden="true">
      <path d="M2.5 6.2l2.2 2.2 4.8-4.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    Sharia Compliant
  </span>
</template>

<script>
/**
 * The Sharia Compliant mark, beside a deal's type badge wherever that shows. Outlined rather than
 * filled so it never reads as a kind of deal: a fund or a note can carry it as well as equity.
 * The sponsor sets it when creating the deal; renders nothing for a deal without it.
 */
export default {
  name: "ShariaBadge",
  props: {
    token: { type: Object, default: null },
    // "md" for cards and the trade page, "sm" for compact rows
    size: { type: String, default: "md" },
  },
};
</script>

<style lang="scss" scoped>
$sharia: #0f766e;

.sharia-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  flex-shrink: 0;
  padding: 3px 9px;
  border: 1px solid rgba($sharia, 0.45);
  border-radius: 7px;
  background: #ffffff;
  color: $sharia;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;

  svg { width: 11px; height: 11px; }

  &.sm {
    padding: 1px 7px;
    border-radius: 4px;
    font-size: 10px;
    svg { width: 10px; height: 10px; }
  }
}
</style>
